import { renderDate } from '../utility/personTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  ptsAssociateID: null,
  Relationship: '',
  RelationshipForAssociate: '',
  IsKeepSeparate: false,
};

export const ASSOCIATE_GRID_COLUMNS = [
  { field: 'FullName', headerName: 'Full Name', width: 200 },
  { field: 'Relationship', headerName: 'Relationship', width: 170 },
  {
    field: 'RelationshipForAssociate',
    headerName: 'Relationship For Associated Person',
    width: 240,
  },
  { field: 'IsKeepSeparate', headerName: 'Keep Separate', width: 150, type: 'boolean' },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
